import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { AssesmentSchedulerService } from 'src/app/core/services/assesment-scheduler/assesment-scheduler.service';
import {
  extraColumnDto,
  navBarProjectManagmentDto,
} from 'src/app/core/models/Assesment-scheduler/scheduler';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import { DeleteDialogComponent } from '../../distributed-ui-components';
import { MatDialog } from '@angular/material/dialog';
import { AddDropdownOptionComponent } from '../add-dropdown-option/add-dropdown-option.component';

@Component({
  selector: 'app-project-name-list',
  templateUrl: './project-name-list.component.html',
  styleUrls: ['./project-name-list.component.scss'],
})
export class ProjectNameListComponent implements OnInit {
  columnList!: extraColumnDto[];
  projectTrackerList!: navBarProjectManagmentDto[];
  projectOptionList!: any;
  index: number = 1;
  isSaveLoader: boolean = false;
  alertDialogModel: AlertDialogModel = new AlertDialogModel();
  constructor(
    public _assesmentSchedulerService: AssesmentSchedulerService,
    public dialog: MatDialog
  ) {}
  ngOnInit(): void {
    this.getData();
  }
  getData() {
    this._assesmentSchedulerService.getAllProjectNameData().subscribe((res) => {
      this.columnList = res.result.columnList;
      this.projectTrackerList = res.result.projectTrackerList;
      for (let item of this.projectTrackerList) {
        item.isAllow = [];
        for (let obj of this.columnList) {
          const projectArr = obj.project.split(',');
          let isExsist = projectArr.find((x) => parseInt(x) == item.id);
          if (isExsist) {
            item.isAllow.push(true);
          } else {
            item.isAllow.push(false);
          }
        }
      }
    });
  }
  addNewProFn() {
    this.projectTrackerList.push({
      id: 0,
      parentId: 815,
      screenName: `Project Tracker ${this.index}`,
      screenUrl: '',
      isAllow: [true, true, true, true, true],
    });
    this.index++;
  }
  saveNewProjectTrackerFn() {
    this.isSaveLoader = true;
    this._assesmentSchedulerService
      .saveNewProjectName({
        columnList: this.columnList,
        projectTrackerList: this.projectTrackerList,
      })
      .subscribe((res) => {
        if (res.result) {
          this.isSaveLoader = false;
          window.location.reload();
        }
      });
  }
  projectAvaliable(id: number, index: number) {
    this.projectTrackerList.map((res) => {
      if (res.id == id) {
        res.isAllow[index] = !res.isAllow[index];
      }
    });
  }
  deleteProjecTracker(itemId: number) {
    this.alertDialogModel.HeadingText = 'Delete Project Tracker';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === this.alertDialogModel.HeadingText) {
        this._assesmentSchedulerService
          .deleteProjectTrackerItem(itemId)
          .subscribe((res) => {
            window.location.reload();
          });
      }
    });
  }
  dropdownPopup(item: extraColumnDto, index: number) {
    if (item.type == 'dropdown') {
      const dialogRef = this.dialog.open(AddDropdownOptionComponent, {
        width: '450px',
        data: {
          item: item,
        },
      });
      dialogRef.afterClosed().subscribe((result: any) => {});
    }
  }
  changeType(item: extraColumnDto, index: number) {
    if (item.type == 'dropdown') {
      this.columnList[index].type = 'text';
    } else {
      this.columnList[index].type = 'dropdown';
    }
    this.columnList[index].option = [];
  }
}
